// extracted by mini-css-extract-plugin
export default {"menuContainer":"styles_menuContainer__1eseq","menuItem":"styles_menuItem__wT9Pv","linkItem":"styles_linkItem__0herQ"};